import {
	Grid,
	Typography,
	Checkbox,
	Button,
	InputBase,
	ButtonBase,
	Box,
} from '@mui/material';
import { helperText } from '../assets/theme/Theme';
import TextInput from '../components/TextInput';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import {
	getRememberMe,
	setElderHomeId,
	setExpireTime,
	setRememberMe,
	setUserName,
} from '../Utils/AuthUtil';
import { fetchUser, loginUser } from '../services/UserService';
import Logo from '../assets/images/Logo.png';
import { EyeIcon, HideEyeIcon } from '../assets/icons/Icons';
import { getEnabledUserFeatures } from '../context/MainProvider';
import { USER_ROLES } from '../Utils/Enums';

const initialErrorState = {
	status: false,
	msg: '',
};

function Login(params) {
	const navigator = useNavigate();
	const { storeEnabledUserFeatures } = getEnabledUserFeatures();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [remember, setRemember] = useState(0);
	const [emailError, setEmailError] = useState(initialErrorState);
	const [passwordError, setPasswordError] = useState(initialErrorState);
	const [loginStatus, setLoginStatus] = useState(initialErrorState);
	const [show, setShow] = useState(false);

	function onChangeEmail(value) {
		setEmailError(initialErrorState);
		setEmail(value);
	}

	function onChangePassword(event) {
		setPasswordError(initialErrorState);
		setPassword(event.target.value);
	}

	async function logIn(params) {
		let error = false;
		if (!email || email === '') {
			setEmailError({ status: true, msg: 'Email is Required.' });
			error = true;
		}

		if (email !== '' && email.indexOf('@') === -1) {
			setEmailError({ status: true, msg: 'Invalid Email' });
			error = true;
		}

		if (!password || password === '') {
			setPasswordError({ status: true, msg: 'Password is Required.' });
			error = true;
		}

		if (error) {
			return;
		} else {
			setLoginStatus(initialErrorState);

			const response = await loginUser(email, password);

			if (
				response.status === 200 &&
				(response.role === USER_ROLES.admin ||
					response.role === USER_ROLES.staff)
			) {
				await fetchUserData(
					response.userId,
					response.token,
					response.role,
				);
				setExpireTime('admin');
				navigator('/home');
			} else if (
				response.status === 200 &&
				response.role === USER_ROLES.superAdmin
			) {
				setUserName('Super Admin');
				navigator('/admin');
				setExpireTime();
			} else if (response.status === 400) {
				setLoginStatus({
					status: true,
					msg: 'Email or password is incorrect',
				});
			} else {
				setLoginStatus({
					status: true,
					msg: 'Something went wrong, please try again.',
				});
			}
		}
	}

	const onChangeRememberMe = () => {
		const val = parseInt(getRememberMe());
		if (val === 0 || val === 2) {
			setRemember(1);
			setRememberMe(1);
		}
		if (val === 1) {
			setRemember(0);
			setRememberMe(0);
		}
	};

	async function fetchUserData(id, token, role) {
		const route = role === USER_ROLES.staff ? 'staff' : 'admin';
		const data = await fetchUser(id, token, route);
		if (data.content) {
			storeEnabledUserFeatures(data.content.featuresTypes);
			setUserName(data.content.username);
			setElderHomeId(data.content.elderHomeId);
		}
	}

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '100vh',
			}}>
			<Grid container justifyContent={'center'}>
				<Grid item xs={10} md={4}>
					<Grid
						container
						flexDirection={'row'}
						justifyContent={'center'}
						alignItems={'center'}>
						<Box
							component={'img'}
							src={Logo}
							sx={{
								padding: '2px',
								borderRadius: '5px',
							}}
							width={180}
							height={45}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						md={12}
						style={{
							textAlign: 'left',
							border: '1px solid #F4F5F6',
							boxShadow:
								'0px 10px 110px 1px rgba(59, 59, 59, 0.08)',
							marginTop: '20px',
							paddingTop: '20px',
							padding: '15px',
							borderRadius: '10px',
							backgroundColor: '#FFF',
						}}>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingBottom="10px">
							Email
						</Typography>
						<TextInput
							error={emailError.status}
							onChange={onChangeEmail}
							onKeyPress={e => e.code === 'Enter' && logIn()}
							width="100%"
							style={{
								marginTop: '5px',
								marginBottom: '10px',
							}}
						/>
						<Typography style={helperText}>
							{emailError.msg}
						</Typography>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingY="10px">
							Password
						</Typography>
						<Grid
							container
							justifyContent={'space-between'}
							alignItems={'center'}
							border={
								passwordError.status
									? '1px solid red'
									: '1px solid #D9D9D9'
							}
							color={'#777E90'}
							paddingX={'15px'}
							borderRadius={'5px'}>
							<InputBase
								type={show === false ? 'password' : 'text'}
								sx={{
									padding: '4px',
									width: '90%',
									color: '#777E90',
								}}
								error={passwordError.status}
								onChange={onChangePassword}
								onKeyPress={e => e.code === 'Enter' && logIn()}
							/>
							<ButtonBase onClick={() => setShow(!show)}>
								{show ? (
									<HideEyeIcon error={passwordError.status} />
								) : (
									<EyeIcon error={passwordError.status} />
								)}
							</ButtonBase>
						</Grid>
						<Typography style={helperText}>
							{passwordError.msg}
						</Typography>
						<Grid container justifyContent={'space-between'}>
							<Grid>
								<Checkbox
									style={{
										paddingLeft: '0px',
										paddingRight: '0px',
									}}
									size="small"
									color="success"
									disableRipple
									onChange={() => onChangeRememberMe()}
									checked={remember === 0 ? false : true}
								/>
								<Typography
									variant="subtitle2"
									style={{
										display: 'inline',
										color: '#B1B5C3',
										paddingLeft: '2px',
									}}>
									Remember me
								</Typography>
							</Grid>
							<a style={{ textDecoration: 'none' }} href="/reset">
								<Typography
									variant="subtitle2"
									color={'#28696D'}
									style={{ paddingTop: '10px' }}>
									Forgot your password?
								</Typography>
							</a>
						</Grid>
						{loginStatus.status && (
							<Grid container justifyContent={'center'}>
								<Typography style={helperText}>
									{loginStatus.msg}
								</Typography>
							</Grid>
						)}
						<Grid container>
							<Button
								onClick={logIn}
								style={{
									width: '100%',
									boxShadow: 'none',
									marginTop: '10px',
									textTransform: 'none',
									backgroundColor: '#28696D',
								}}
								variant="contained">
								Log in
							</Button>
							<Grid
								container
								flexDirection={'row'}
								paddingY={'15px'}>
								<Typography
									variant="subtitle2"
									color={'#777E91'}>
									Create a new account
								</Typography>
								<Typography
									variant="subtitle2"
									style={{
										color: '#28696D',
										paddingLeft: '3px',
									}}>
									<a
										href="/createAccount"
										style={{ textDecoration: 'none' }}>
										<span
											style={{
												color: '#28696D',
												cursor: 'pointer',
												textDecoration: 'underline',
											}}>
											Signup
										</span>
									</a>
								</Typography>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	);
}

export default Login;
